import React from "react"
import { Tabs, Tab, Box, Typography } from "@mui/material"
import NewLogs from "./NewLogs"
import OldLogs from "./OldLogs"

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  )
}

const Logs = ({ serialNo, approvedData, onClose, open }) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "background.paper",
      }}
    >
      {/* Vertical Tabs */}
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        sx={{ borderRight: 1, borderColor: "divider", width: 180 }}
      >
        <Tab label="New Logs" />
        <Tab label="Old Logs" />
      </Tabs>

      <Box sx={{ flex: 1 }}>
        <TabPanel value={value} index={0}>
          <NewLogs
            serialNo={serialNo}
            approvedData={approvedData}
            onClose={onClose}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <OldLogs serialNo={serialNo} onClose={onClose} />
        </TabPanel>
      </Box>
    </Box>
  )
}

export default Logs
